const GRID_ITEMS = [
  {
    label: "Manufacturing",
    image: "https://customer-assets.emergentagent.com/job_eleven-41-preview/artifacts/jocwqdko_Aerial.jpg",
    span: "md:col-span-2",
  },
  {
    label: "Warehousing",
    image: "https://customer-assets.emergentagent.com/job_eleven-41-preview/artifacts/3wkhv3fg_Warehouse_1_FINAL.jpg",
    span: "md:col-span-1",
  },
  {
    label: "Distribution",
    image: "https://customer-assets.emergentagent.com/job_eleven-41-preview/artifacts/ubbrwaym_ChatGPT%20Image%20Apr%2014%2C%202026%2C%2003_32_16%20PM.png",
    span: "md:col-span-1",
  },
  {
    label: "Office",
    image: "https://customer-assets.emergentagent.com/job_eleven-41-preview/artifacts/yxfiyjzh_Office_FINAL.jpg",
    span: "md:col-span-2",
  },
  {
    label: "Retail",
    image: "https://customer-assets.emergentagent.com/job_eleven-41-preview/artifacts/lt7tsgrh_1141%20Map%20%283%29.png",
    span: "md:col-span-1",
  },
  {
    label: "Global Services",
    image: "https://customer-assets.emergentagent.com/job_eleven-41-preview/artifacts/i55w1szp_CallCenter_FINAL_Logo.jpg",
    span: "md:col-span-2",
  },
];

export default function DeliversGrid() {
  return (
    <section
      id="spaces"
      data-testid="delivers-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <span
          className="text-xs font-semibold tracking-[0.2em] uppercase text-[#D49A38] block"
          style={{ fontFamily: "Manrope, sans-serif" }}
          data-testid="delivers-overline"
        >
          What We Deliver
        </span>
        <div className="w-12 h-[2px] bg-[#D49A38] mt-4 mb-6" />

        <h2
          className="mt-0 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#182649] tracking-tight leading-[1.1] uppercase mb-12"
          style={{ fontFamily: "Outfit, sans-serif" }}
          data-testid="delivers-headline"
        >
          Flexible space for <span className="text-[#D49A38]">modern</span> operations
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {GRID_ITEMS.map((item) => (
            <div
              key={item.label}
              className={`grid-card relative overflow-hidden rounded-md h-64 md:h-72 cursor-pointer group ${item.span}`}
              data-testid={`grid-card-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <img
                src={item.image}
                alt={item.label}
                className="grid-card-img absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 p-6">
                <span
                  className="text-white text-lg font-medium tracking-wide"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {item.label}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
